/**
 * GTM Custom Events
 *
 * Zentrale Datei für alle benutzerdefinierten GTM/DataLayer Events.
 * Wird nur auf relevanten Seiten geladen (z.B. PDP).
 *
 * Usage:
 * - Events werden automatisch beim Laden der Seite registriert
 * - Neue Events können einfach in der initEvents() Funktion hinzugefügt werden
 */

(function () {
  "use strict";

  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  /**
   * Extract numeric price from text like "Angebot€89,99" → "89.99"
   */
  function extractPrice(text) {
    if (!text) return "";
    var match = text.replace(/\s/g, "").match(/(\d[\d.,]*\d)/);
    if (!match) return "";
    // Use last occurrence of comma or dot as decimal separator
    var raw = match[1];
    var lastComma = raw.lastIndexOf(",");
    var lastDot = raw.lastIndexOf(".");
    if (lastComma > lastDot) {
      // Comma is decimal separator (e.g. "1.089,99" or "89,99")
      return raw.replace(/\./g, "").replace(",", ".");
    }
    // Dot is decimal separator or no separator
    return raw.replace(/,/g, "");
  }

  /**
   * Push event to dataLayer
   * @param {string} eventName - Name des Events
   * @param {object} eventData - Zusätzliche Event-Daten
   */
  function pushEvent(eventName, eventData) {
    var data = Object.assign({ event: eventName }, eventData || {});
    window.dataLayer.push(data);

    // Debug logging (kann in Produktion entfernt werden)
    if (window.location.search.indexOf("gtm_debug") > -1) {
      console.log("[GTM Event]", eventName, data);
    }
  }

  /**
   * Click-Event auf Element registrieren
   * @param {string} selector - CSS Selector
   * @param {string} eventName - GTM Event Name
   * @param {function|object} dataCallback - Funktion oder Objekt für Event-Daten
   */
  function trackClick(selector, eventName, dataCallback) {
    document.addEventListener("click", function (e) {
      var target = e.target.closest(selector);
      if (target) {
        var eventData =
          typeof dataCallback === "function"
            ? dataCallback(target, e)
            : dataCallback || {};
        pushEvent(eventName, eventData);
      }
    });
  }

  /**
   * Alle Custom Events initialisieren
   */
  function initEvents() {
    // =========================================================================
    // PDP Events
    // =========================================================================
    // Beispiel: Add to Cart Button Klick
    // trackClick('.product-form__submit', 'pdp_add_to_cart_click', function(el) {
    //   return {
    //     product_title: document.querySelector('.product__title')?.textContent?.trim(),
    //     button_text: el.textContent?.trim()
    //   };
    // });
    // Beispiel: Variant Selector Änderung
    // trackClick('.variant-picker__option', 'pdp_variant_select', function(el) {
    //   return {
    //     variant_option: el.textContent?.trim()
    //   };
    // });
    // Beispiel: Accordion öffnen
    // trackClick('.product-accordion__toggle', 'pdp_accordion_click', function(el) {
    //   return {
    //     accordion_title: el.querySelector('.accordion__title')?.textContent?.trim()
    //   };
    // });
    // =========================================================================
    // Related Products Slider - Produkt Klick
    // =========================================================================

    // Klick auf Produkt-Link im "Ähnliche Produkte" Slider
    trackClick(
      '.shopify-section--product-recommendations product-card a[href*="/products/"]',
      "related_products_click",
      function (el) {
        var productCard = el.closest("product-card");
        var productTitle = productCard
          ? productCard
              .querySelector(".product-card__title a")
              ?.textContent?.trim()
          : "";
        var productHandle = productCard
          ? productCard.getAttribute("handle")
          : "";
        var productPrice = productCard
          ? extractPrice(productCard.querySelector("sale-price")?.textContent)
          : "";

        return {
          click_location: "related_products_slider",
          clicked_product_title: productTitle,
          clicked_product_handle: productHandle,
          clicked_product_price: productPrice,
        };
      }
    );

    // =========================================================================
    // Shop the Look - Produkt Klick
    // =========================================================================

    trackClick(
      '.shop-the-look product-card a[href*="/products/"]',
      "shop_the_look_click",
      function (el) {
        var productCard = el.closest("product-card");
        var productTitle = productCard
          ? productCard
              .querySelector(".product-card__title a")
              ?.textContent?.trim()
          : "";
        var productHandle = productCard
          ? productCard.getAttribute("handle")
          : "";
        var productPrice = productCard
          ? extractPrice(productCard.querySelector("sale-price")?.textContent)
          : "";

        return {
          click_location: "shop_the_look",
          clicked_product_title: productTitle,
          clicked_product_handle: productHandle,
          clicked_product_price: productPrice,
        };
      }
    );

    // =========================================================================
    // Recently Viewed Products - Produkt Klick
    // =========================================================================

    trackClick(
      '.shopify-section--recently-viewed-products product-card a[href*="/products/"]',
      "recently_viewed_click",
      function (el) {
        var productCard = el.closest("product-card");
        var productTitle = productCard
          ? productCard
              .querySelector(".product-card__title a")
              ?.textContent?.trim()
          : "";
        var productHandle = productCard
          ? productCard.getAttribute("handle")
          : "";
        var productPrice = productCard
          ? extractPrice(productCard.querySelector("sale-price")?.textContent)
          : "";

        return {
          click_location: "recently_viewed",
          clicked_product_title: productTitle,
          clicked_product_handle: productHandle,
          clicked_product_price: productPrice,
        };
      }
    );

    // =========================================================================
    // Cross-Sell – Produkt-Klick auf PDP
    // =========================================================================

    // Klick auf Produkttitel in der custom Recommendations-Sektion
    trackClick(
      ".pdp-custom-recommendations__item-title",
      "crosssell_product_click",
      function (el) {
        var item = el.closest(".pdp-custom-recommendations__item");
        var priceEl = item ? item.querySelector("sale-price") : null;
        return {
          click_location: "crosssell_recommendations",
          clicked_product_title: el.textContent.trim(),
          clicked_product_handle: (el.getAttribute("href") || "").replace(
            "/products/",
            ""
          ),
          clicked_product_price: priceEl
            ? extractPrice(priceEl.textContent)
            : "",
        };
      }
    );

    // Klick auf Produktlink (Bild oder Titel) im Candy Rack Cross-Sell
    // Candy Rack rendert <a> ohne href und Bilder als <div>, daher auf Klasse matchen
    trackClick(
      '.candyrack-ppp-button-layout__info--product-name, .candyrack-ppp-button-layout__offer [class*="offerProductImageWrapperClickable"]',
      "crosssell_product_click",
      function (el) {
        var offer = el.closest(".candyrack-ppp-button-layout__offer");
        var titleEl = offer
          ? offer.querySelector('[class*="offerProductTitle"]')
          : null;
        // Candy Rack rendert den Preis mit dynamischen Klassen – mehrere Selektoren probieren
        var priceEl = offer
          ? offer.querySelector(
              '[class*="offerPrice"], [class*="offerSalePrice"], [class*="Price"]:not([class*="Title"]):not([class*="Button"])'
            )
          : null;
        return {
          click_location: "crosssell_candyrack",
          clicked_product_title: titleEl ? titleEl.textContent.trim() : "",
          clicked_product_handle: "",
          clicked_product_price: priceEl
            ? extractPrice(priceEl.textContent)
            : "",
        };
      }
    );

    // =========================================================================
    // Cross-Sell (Candy Rack) – Add to Cart Events
    // =========================================================================

    // Einvariante – Candy Rack macht nativ Add-to-Cart,
    // candyrack-carousel.liquid dispatcht candyrack:addedToCart danach
    document.addEventListener("candyrack:addedToCart", function (e) {
      pushEvent("crosssell_add_to_cart", {
        add_type: "single_variant",
        product_title: e.detail.productTitle,
        product_handle: e.detail.productHandle,
        variant_id: e.detail.variantId,
        variant_title: e.detail.variantTitle,
        price: e.detail.price,
        source: "candyrack_crosssell",
      });
    });

    // Mehrvariantig – Quick Buy Drawer (id starts with "candyrack-quick-buy-")
    document.addEventListener("variant:add", function (e) {
      var drawer = document.querySelector('quick-buy-drawer[id^="candyrack-quick-buy-"]');
      if (!drawer) return;

      var addedItem = e.detail && e.detail.items && e.detail.items[0];
      var drawerHandle = drawer.id.replace("candyrack-quick-buy-", "").split("?")[0];
      pushEvent("crosssell_add_to_cart", {
        add_type: "multi_variant",
        product_title: (addedItem && addedItem.title) || "",
        product_handle: (addedItem && addedItem.handle) || drawerHandle || "",
        variant_id: addedItem ? addedItem.variant_id : null,
        variant_title: addedItem ? addedItem.variant_title : null,
        price: addedItem ? addedItem.price / 100 : null,
        source: "candyrack_crosssell",
      });
    });

    // =========================================================================
    // Füge hier weitere Events hinzu
    // =========================================================================
  }

  // Events initialisieren wenn DOM bereit ist
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initEvents);
  } else {
    initEvents();
  }
})();
